/** @jsx jsx */
import { Badge, jsx, Message, Text } from "theme-ui";
import PropTypes from "prop-types";
import useMyBoolean from "sites-common/hooks/useMyBoolean";
import {
  ActionButton,
  DefaultButton,
  Icon,
  Panel,
  PanelType,
  Stack,
  StackItem,
} from "office-ui-fabric-react";

import { useSelector } from "react-redux";
import { useFirestore } from "react-redux-firebase";
import { useEffect, useState } from "react";
import useAuth from "gatsby-plugin-hfn-profile/auth/useAuth";
import {
  Table,
  TableCell,
  TableHead,
  TableRow,
} from "sites-common/components/ui/DivTable";
import strings from "./strings.json";
import MyRecords from "./my-entries";
import NewEntry from "./new-entry";
import { encode2 } from "../../../lib/encodedecode";
import { collection_admin, overall } from "./adminconstants";

const peach = "#FFE5B4";
// const fields = [
//   { name: "value", label: "Enter Abhyasi ID or mobile or email" },
// ];

const collection = collection_admin;
const storeAs = collection_admin;

function RecordsApp({ q }) {
  const [add, { setTrue: doShowAdd, setFalse: doHideAdd }] =
    useMyBoolean(false);
  const firestore = useFirestore();
  const [accordion, setAccordion] = useState(0);

  const adminConfigRecs = useSelector((state) =>
    storeAs in state.firestore.ordered
      ? state.firestore.ordered[storeAs]
      : undefined
  );

  useEffect(() => {
    const listenerSettings = q
      ? {
          collection,
          doc: q,
          storeAs,
        }
      : {
          collection,
          storeAs,
        };
    firestore.setListener(listenerSettings);
    return function cleanup() {
      firestore.unsetListener(listenerSettings);
    };
  }, [firestore, q]);

  const { srcmProfile } = useAuth();
  const [isPOCPanelOpen, { toggle: togglePOCPanel }] = useMyBoolean(false);

  return (
    <div>
      <div sx={{ textAlign: "center", m: 2 }}>
        <Text variant="header">{strings.title}</Text>
        <br />
        <Text variant="subtitle">{strings.subtitle}</Text>
        <hr />
      </div>
      {!!adminConfigRecs && adminConfigRecs.length < 1 && q && (
        <div>
          <Message>
            <div>
              <Icon iconName="AlertSolid" /> Invalid Event Link{" "}
            </div>
            <ActionButton
              href="all"
              text="Click here to see All Active Events"
            />
          </Message>
        </div>
      )}

      {!!adminConfigRecs &&
        adminConfigRecs
          .filter((adminConfig) => !adminConfig.hideit)
          .map((adminConfig, idx) => {
            const pocDepts = adminConfig?.pocs
              ? Object.entries(adminConfig?.pocs)
                  .filter(
                    ([, obj]) =>
                      !!obj?.leads &&
                      srcmProfile?.id in obj.leads &&
                      !obj?.leads[srcmProfile?.id]?.inactive
                  )
                  .map(([, obj]) => obj.dept)
              : [];
            return (
              <div>
                {isPOCPanelOpen && (
                  <Panel
                    type={PanelType.customNear}
                    headerText="POCs"
                    isOpen
                    onDismiss={togglePOCPanel}
                  >
                    <Table>
                      <TableRow>
                        <TableCell>
                          <b>Overall Supervision / Co-organizers</b>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          {Object.entries(adminConfig?.pocs)
                            .filter(([, row]) => row.dept === overall)
                            .map(([, row]) => (
                              <table>
                                {!!row?.leads &&
                                  Object.values(row.leads)
                                    .filter((lead) => !lead.inactive)
                                    .map((lead) => {
                                      return (
                                        <tr>
                                          <td>{lead.name}</td>
                                          <td sx={{ px: 4 }}>{lead.city}</td>
                                          <td>{lead.mobile}</td>
                                        </tr>
                                      );
                                    })}
                              </table>
                            ))}
                        </TableCell>
                      </TableRow>
                    </Table>
                    <Table sx={{ mt: 2, bg: peach }}>
                      <TableRow>
                        <TableHead>Department</TableHead>
                        <TableHead>POCs</TableHead>
                        <TableHead>No. of Volunteers Required</TableHead>
                      </TableRow>
                      {Object.entries(adminConfig?.pocs)
                        .filter(([, row]) => row.dept !== overall)
                        .sort((a, b) => a[0] > b[0])
                        .map(([, row]) => (
                          <TableRow>
                            <TableCell sx={{ fontWeight: 700 }}>
                              {row.dept === overall
                                ? "Overall Supervision / Co-organizers"
                                : row.dept}
                            </TableCell>
                            <TableCell>
                              <table>
                                {!!row?.leads &&
                                  Object.values(row.leads)
                                    .filter((lead) => !lead.inactive)
                                    .map((lead) => {
                                      return (
                                        <tr>
                                          <td>{lead.name}</td>
                                          <td sx={{ px: 4 }}>{lead.city}</td>
                                          <td>{lead.mobile}</td>
                                        </tr>
                                      );
                                    })}
                              </table>
                            </TableCell>
                            <TableCell align="center">{row?.num}</TableCell>
                          </TableRow>
                        ))}
                    </Table>
                  </Panel>
                )}
                <Stack
                  horizontal
                  verticalAlign="center"
                  sx={{
                    cursor: "pointer",
                    bg: "darkblue",
                    color: "white",
                    mb: 2,
                    borderRadius: 5,
                    p: 2,
                  }}
                  onClick={() => setAccordion(idx)}
                  tokens={{ childrenGap: 8 }}
                >
                  <StackItem>
                    <Icon
                      iconName={
                        idx !== accordion
                          ? "ChevronRightSmall"
                          : "ChevronDownSmall"
                      }
                    />
                  </StackItem>
                  <StackItem sx={{ fontWeight: 700, fontSize: "1.1em" }}>
                    {adminConfig.title}
                  </StackItem>
                </Stack>
                {idx === accordion && (
                  <div>
                    <div sx={{ p: 2, fontSize: "0.86em" }}>
                      {adminConfig.note}
                    </div>
                    <DefaultButton
                      text="View POCs"
                      iconProps={{ iconName: "Forward" }}
                      onClick={togglePOCPanel}
                    />

                    {pocDepts.length > 0 && (
                      <div
                        sx={{
                          m: 2,
                          border: "1px solid lightblue",
                          bg: peach,
                          p: 2,
                          fontWeight: 700,
                          fontSize: "0.8em",
                        }}
                      >
                        <div>I am POC for Volunteering Departments:</div>
                        <table>
                          <tbody>
                            {pocDepts.map((n) => (
                              <tr>
                                <td>
                                  <Badge sx={{ mr: 3 }}>
                                    {n === overall ? "Overall Supervision" : n}
                                  </Badge>{" "}
                                </td>
                                <td>
                                  <a
                                    href={`poc?q=${encodeURIComponent(
                                      encode2(
                                        srcmProfile.uid,
                                        JSON.stringify({
                                          dept: n,
                                          title: adminConfig.title,
                                          oppy: adminConfig.id,
                                          aims_flds: adminConfig.aims_flds,
                                          visit_flds: adminConfig.visit_flds,
                                        })
                                      )
                                    )}`}
                                  >
                                    Open POC Page
                                  </a>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    <div>
                      <Text sx={{ mt: 1, p: 1 }} variant="subtitle">
                        My Volunteer Registrations
                      </Text>
                    </div>
                    <div sx={{ mb: 3 }}>
                      <MyRecords adminConfig={adminConfig} />
                      {adminConfig.active && (
                        <div>
                          {!add && (
                            <div>
                              <DefaultButton
                                primary
                                iconProps={{ iconName: "Add" }}
                                text={strings.btn_add_abhyasi}
                                onClick={doShowAdd}
                              />
                            </div>
                          )}
                          {add && (
                            <Panel
                              isOpen
                              headerText="Add Volunteers"
                              type={PanelType.medium}
                              hasCloseButton
                              onDismiss={doHideAdd}
                            >
                              <NewEntry
                                onDone={doHideAdd}
                                adminConfig={adminConfig}
                              />
                            </Panel>
                          )}
                        </div>
                      )}
                      <hr />
                    </div>
                  </div>
                )}
              </div>
            );
          })}
    </div>
  );
}

RecordsApp.propTypes = {
  q: PropTypes.string,
};
RecordsApp.defaultProps = {
  q: undefined,
};
export default RecordsApp;
